import { Component, OnInit } from '@angular/core';
import { HeaderStyleTwoComponent } from '../header-style-two/header-style-two.component';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ContactUs } from 'src/app/models/contact-us.model';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
import { ContactListService } from 'src/app/services/contact-list.service';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { HttpClientModule } from '@angular/common/http';
import { LookUpService } from 'src/app/services/lookup.service';
import { SharedModule } from 'src/app/shared/shared.module';
const EMPTY_Model: ContactUs = new ContactUs();

@Component({
    selector: 'app-contact-page',
    templateUrl: './contact-page.component.html',
})
export class ContactPageComponent implements OnInit {

    formGroup: FormGroup;
    contactUs: ContactUs;
    img: string;
    phone: string;
    location: string;
    locationMap: string;
    homePage_Section7: string;
    email: string;
    isToggled = false;

    constructor(private fb: FormBuilder,
        public themeService: ThemeCustomizerService, public contactListService: ContactListService,
        private lookUpService: LookUpService,

    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.lookUpService.getAll$().subscribe(x => {
            this.email = x.find(x => x?.name == "Email")?.value;
            this.phone = x.find(x => x?.name == "Phone")?.value;
            this.locationMap = x.find(x => x?.name == "LocationMap")?.value;
            this.location = x.find(x => x?.name == "Location")?.value;
            this.contactImg = x.find(x => x?.name == "ContactImg")?.value;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }
    contactImg: string;
    ngOnInit(): void {
       
        this.loadForm();
    }
    createImgPath = (serverPath: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }
    loadForm() {

        this.contactUs = EMPTY_Model;
        this.formGroup = this.fb.group({
            name: [this.contactUs?.name, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
            email: [this.contactUs?.email, Validators.compose([Validators.required, Validators.email, Validators.minLength(1), Validators.maxLength(100)])],
            message: [this.contactUs.message, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
            phone: [this.contactUs?.phone, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
        });
    }

    submitted = false;
    get f(): { [key: string]: AbstractControl } {
        return this.formGroup.controls;
    }
    create() {
        this.submitted = true;
        if (this.formGroup.invalid) {
            Swal.fire({
                // position: 'top-end',
                icon: 'error',
                title: 'Please Fill All Field',
                showConfirmButton: false,
                timer: 1000
            })
            return;
        }
        else {
            this.prepareForm();
            const sbCreate = this.contactListService.addContactUs$(this.contactUs).
                subscribe((res: ContactUs) => this.contactUs = res);
            this.formGroup.reset();
            Swal.fire({
                // position: 'top-end',
                icon: 'success',
                title: 'Your Data has been saved',
                showConfirmButton: false,
                timer: 1500
            })
        }

    }

    private prepareForm() {
        const formData = this.formGroup.value;
        this.contactUs.name = formData.name;
        this.contactUs.email = formData.email;
        this.contactUs.message = formData.message;
        this.contactUs.phone = formData.phone.toString();
    }

    // helpers for View
    isControlValid(controlName: string): boolean {
        const control = this.formGroup.controls[controlName];
        return control.valid && (control.dirty || control.touched);
    }

    isControlInvalid(controlName: string): boolean {
        const control = this.formGroup.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }

    controlHasError(validation, controlName): boolean {
        const control = this.formGroup.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    isControlTouched(controlName): boolean {
        const control = this.formGroup.controls[controlName];
        return control.dirty || control.touched;
    }


}